import type { TranslationStrings } from "../types";

export const en: TranslationStrings = {
  "All set!": "All set!",
  "Your World ID is now connected": "Your World ID is now connected",
  "Already verified": "Already verified",
  "You've already verified for this action.":
    "You've already verified for this action.",
  "Something went wrong": "Something went wrong",
  "Request cancelled": "Request cancelled",
  "You've cancelled the request in World ID App.":
    "You've cancelled the request in World ID App.",
  "Verification unavailable": "Verification unavailable",
  "This verification request couldn't be completed. Please contact the website owner.":
    "This verification request couldn't be completed. Please contact the website owner.",
  "Connection lost": "Connection lost",
  "Please check your connection and try again.":
    "Please check your connection and try again.",
  "Verification declined": "Verification declined",
  "Failed to verify your credential proof. Please contact the website owner.":
    "Failed to verify your credential proof. Please contact the website owner.",
  "Verification requirements not met": "Verification requirements not met",
  "Your World ID doesn't meet the requirements for this verification.":
    "Your World ID doesn't meet the requirements for this verification.",
  "Presence check failed": "Presence check failed",
  "World ID App couldn't confirm your presence for this request.":
    "World ID App couldn't confirm your presence for this request.",
  "We couldn't complete your request. Please try again.":
    "We couldn't complete your request. Please try again.",
  "Try Again": "Try Again",
  Close: "Close",
  "Open World ID App": "Open World ID App",
  "Display QR Code": "Display QR Code",
  "Hide QR Code": "Hide QR Code",
  or: "or",
  "QR Code copied": "QR Code copied",
  "Connect your World ID": "Connect your World ID",
  "Use phone camera to scan the QR code":
    "Use phone camera to scan the QR code",
  "Connecting...": "Connecting...",
  "Please continue in app": "Please continue in app",
  "Transmitting verification to host app. Please wait...":
    "Transmitting verification to host app. Please wait...",
  "You will be redirected to the app, please return to this page once you're done":
    "You will be redirected to the app, please return to this page once you're done",
  "Scan with your phone to continue verifying":
    "Scan with your phone to continue verifying",
  "Open Connector URL": "Open Connector URL",
  "Or enter this code in World ID App": "Or enter this code in World ID App",
  Copy: "Copy",
  "Expires in": "Expires in",
  "Terms & Privacy": "Terms & Privacy",
};
